import { KIND } from 'baseui/button'
import { ANCHOR, Drawer } from 'baseui/drawer'
import {
  TriggerButton,
  TriggerIcon,
  TriggerText,
} from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/styled-components'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import IconListBulleted from '@/shared/icons/NewDesign/IconListBulleted'
import TodayCallbackRow from './TodayCallbackRow/TodayCallbackRow'
import useTodayCallbacks from './useTodayCallbacks'
import { ButtonSpacer, CallbackList, DrawerTitle, StateMessage } from './styled-components'

const TodayCallbacks = () => {
  const {
    isAvailable,
    isOpen,
    isLoading,
    hasError,
    isEmpty,
    rows,
    open,
    close,
    retry,
    buttonLabel,
    title,
    emptyLabel,
    errorLabel,
    retryLabel,
    loadingLabel,
    drawerOverrides,
  } = useTodayCallbacks()

  if (!isAvailable) return null

  return (
    <ButtonSpacer>
      <TriggerButton type='button' onClick={open} aria-haspopup='dialog'>
        <TriggerIcon>
          <IconListBulleted size={16} />
        </TriggerIcon>
        <TriggerText>{buttonLabel}</TriggerText>
      </TriggerButton>
      <Drawer isOpen={isOpen} onClose={close} anchor={ANCHOR.right} autoFocus overrides={drawerOverrides}>
        <DrawerTitle>{title}</DrawerTitle>
        <StateMessage hidden={!isLoading}>{loadingLabel}</StateMessage>
        <StateMessage hidden={!isEmpty}>{emptyLabel}</StateMessage>
        <StateMessage hidden={!hasError}>{errorLabel}</StateMessage>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton kind={KIND.secondary} hidden={!hasError} onClick={retry}>
          {retryLabel}
        </SDButton>
        <CallbackList hidden={isLoading || hasError}>
          {rows.map(row => (
            <TodayCallbackRow key={row.id} {...row} />
          ))}
        </CallbackList>
      </Drawer>
    </ButtonSpacer>
  )
}

export default TodayCallbacks
